import { Injectable } from '@angular/core';
import { InjectableMapDataStateService } from '@ui/shared/domain-map';
import type { PreventionListItemModel } from '../definitions/prevention-list-item.model';
import type { PreventionListFilterKey } from '../types/prevention-list-filters';

@Injectable({ providedIn: 'root' })
export class PreventionListMapDataService extends InjectableMapDataStateService<PreventionListItemModel, PreventionListFilterKey> {
}
